module.exports = __webpack_public_path__ + "img/measurement_info_back_hand_right.5e070a64.jpg";